import getIsServiceValid from "./getIsServiceValid";
/**
 * getIsUpdateNewsEnabled
 *
 * @description
 * Determine if the News update functionality should be enabled
 * based on the given input properties of various reviews and an ID.
 * @param {NewsEnabledProps} props - An object containing review properties
 * and News ID.
 * @returns {boolean} - If true, the News update functionality is considered enabled
 * otherwise, false.
 *
 */
const getIsUpdateNewsEnabled = ({ avNirvana, bluRay, hidefDigest, id, news, whySoBlu }) => Boolean(id) &&
    getIsServiceValid(avNirvana, news.sourcesIds) &&
    getIsServiceValid(bluRay, news.sourcesIds) &&
    getIsServiceValid(hidefDigest, news.sourcesIds) &&
    getIsServiceValid(whySoBlu, news.sourcesIds);
export default getIsUpdateNewsEnabled;
